const MONTH_MAP = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
]

const DOW_MAP=[
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thur",
    "Fri",
    "Sat"
]

export function getDateTime() {
    var m = new Date();
    let session = "AM";
    let hh=m.getUTCHours()
    let dow = DOW_MAP[m.getDay()]
    if (hh == 0) {
        hh = 12;
    }
    if (hh > 12) {
        hh = hh - 12;
        session = "PM";
    }
    var dateString =
        dow + " " +
        MONTH_MAP[m.getUTCMonth() ] + " " +
        ("0" + m.getUTCDate()) + " " +
        hh +":"+
        ("0" + m.getUTCMinutes()).slice(-2) + " " +
        session

    return dateString
}